module.exports = __webpack_public_path__ + "assets/img/box1-5.eba9934a.svg";